module.exports = __webpack_public_path__ + "img/floating-bg.ccf9daa.webp";